export enum MiniFormInputType {
  Text = 'inputText',
  Email = 'inputEmail',
  Dropdown = 'dropdown',
  RadioGroup = 'radioGroup',
  DatePicker = 'datePicker',
  Textarea = 'textarea',
  Checkbox = 'checkbox',
  StaticContent = 'staticContent',
  TimePicker = 'timePicker'
}
